/* eslint-disable import/extensions */
import {
  HAS_NUMBER_REGEX,
  NO_NUMBERS_ERROR,
  REQUIRED_FIELD_ERROR,
  FIELD_INVALID,
  isValidCIF,
  isValidNIF,
  isValidNIE,
  isValidPassport,
} from '@masfront/common-b2c'
import { object, string } from 'yup'

import { SignUpType, PortabilityType, Owner } from '~/basket/model/lines/signup.model'

const SAME_DOC = 'El documento no puede ser el mismo que el principal.'

const donorOwnerSchemas = (customerId: string) => ({
  isSameOwner: string()
    .label('titular de origen')
    .when('portabilityType', {
      is: PortabilityType.POSTPAID,
      then: string().required(REQUIRED_FIELD_ERROR),
      otherwise: string(),
    }),
  donorOwner: object().when(['isSameOwner', 'signUpType'], {
    is: (isSameOwner, signUpType) =>
      isSameOwner === Owner.OTHER && signUpType === SignUpType.PORTABILITY,
    then: object().shape({
      name: string().when(['docType'], {
        is: (docType) => docType !== 'CIF',
        then: string()
          .label('nombre')
          .matches(HAS_NUMBER_REGEX, NO_NUMBERS_ERROR)
          .required(REQUIRED_FIELD_ERROR),
        otherwise: string(),
      }),
      firstName: string().when(['docType'], {
        is: (docType) => docType !== 'CIF',
        then: string()
          .matches(HAS_NUMBER_REGEX, NO_NUMBERS_ERROR)
          .label('apellido')
          .required(REQUIRED_FIELD_ERROR),
        otherwise: string(),
      }),
      lastName: string().when(['docType'], {
        is: 'NIF',
        then: string()
          .matches(HAS_NUMBER_REGEX, NO_NUMBERS_ERROR)
          .label('segundo apellido')
          .required(REQUIRED_FIELD_ERROR),
        otherwise: string(),
      }),
      companyName: string().when(['docType'], {
        is: 'CIF',
        then: string().label('nombre de empresa').required(REQUIRED_FIELD_ERROR),
        otherwise: string(),
      }),
      docId: string()
        .label('documento')
        .required(REQUIRED_FIELD_ERROR)
        .test(
          'isNifOrNie',
          FIELD_INVALID,
          (value) =>
            !!value &&
            (isValidNIF(value) || isValidNIE(value) || isValidPassport(value) || isValidCIF(value)),
        )
        .test('sameDoc', SAME_DOC, (value) => !!value && customerId !== value),
      docType: string().required(REQUIRED_FIELD_ERROR),
    }),
    otherwise: object().shape({
      name: string(),
      firstName: string(),
      lastName: string(),
      docType: string(),
      docId: string(),
    }),
  }),
})

export default donorOwnerSchemas
